/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Butter Bar Component
 */

import { cn } from '@zcode-ui/shadz-ui'
import { ButterBarSingleton } from '@zcode-ui/web-zumper-global-state'
import { a11yButtonHandler } from '@zcode/nr/es/shared/utils/a11y'
import PropTypes from 'prop-types'
import React from 'react'
import closeButton from '../../img/common/close_button.svg'

class ButterBar extends React.Component {
  static propTypes = {
    butterBar: PropTypes.object.isRequired,
    first: PropTypes.bool.isRequired,
    last: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      hiding: false,
    }
    this.closeHandler = this.closeHandler.bind(this)
    this.actionClick = this.actionClick.bind(this)
  }

  componentDidMount() {
    ButterBarSingleton.startTimeout(this.props.butterBar)
  }

  componentDidUpdate() {
    const { butterBar, last } = this.props
    if (!last) {
      ButterBarSingleton.cancelTimeout(butterBar)
    } else {
      ButterBarSingleton.startTimeout(butterBar)
    }
  }

  componentWillUnmount() {
    ButterBarSingleton.cancelTimeout(this.props.butterBar)
  }

  actionClick() {
    const { butterBar } = this.props
    butterBar.action && butterBar.action()
    butterBar.removeHandler()
  }

  closeHandler(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.setState(
      {
        hiding: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            hiding: false,
          })
          this.props.butterBar.removeHandler()
        }, 100)
      }
    )
  }

  render() {
    const { butterBar, first, last } = this.props
    const { address, action, actionStyle, actionText, addendum, color, message, persistent } =
      butterBar
    const closeBtnStyle = `bg-transparent border-0 p-0 select-none absolute top-[17px] right-[15px]`
    const BUTTER_BAR_STYLES = [
      'relative',
      'block',
      'min-w-[200px]',
      'max-w-[430px]',
      'm-0',
      'desktop:my-5',
      'desktop:mx-auto',
      'p-[15px_30px_15px_20px]',
      'text-blue-800',
      'text-[15px]',
      'leading-[18px]',
      'text-left',
      'bg-[#d8e8f5]',
      'border',
      'border-black',
      'border-opacity-10',
      'rounded-[0px]',
      'desktop:rounded-[3px]',
      'shadow-md',
      'opacity-95',
      'pointer-events-auto',
      'tap-highlight-transparent',
      'w-full',
      'desktop:w-[inherit]',
      '[animation:fade-in-down_0.2s]',
    ]
    const BUTTER_BAR_COLORS = {
      info: ['text-[#1c3c88]', 'bg-[#d5e0f9]'],
      warning: ['text-[#967d1f]', 'bg-[#fef6d6]'],
      error: ['text-[#983524]', 'bg-[#ffded8]'],
      success: ['text-[#246e41]', 'bg-[#d8f1e2]'],
    }

    return (
      <div
        className={cn(
          ...BUTTER_BAR_STYLES,
          ...BUTTER_BAR_COLORS[color],
          !first && !last && 'mt-[-35px]',
          this.state.hiding && 'opacity-0 [animation:fade-out-up_0.1s]'
        )}
        onClick={this.closeHandler}
        onKeyPress={a11yButtonHandler(this.closeHandler)}
        role="button"
        tabIndex="0"
      >
        {!persistent && (
          <img
            alt="close"
            className={closeBtnStyle}
            height="14"
            loading="lazy"
            src={closeButton}
            width="14"
          />
        )}
        <div>
          {/*
            {
              butterBar.__html &&
              <div dangerouslySetInnerHTML={butterBar}></div>
            }
          */}
          {message && <div>{message}</div>}
          {address && <div>{address}</div>}
          {actionText && action && (
            <button
              className={cn(
                'inline-block text-[#2e64e2] text-sm font-[Moderat] leading-[1.42857143] p-0 no-underline cursor-pointer hover:active:focus:underline md:hover:no-underline'
              )}
              onClick={this.actionClick}
              // normally this is not needed for a button but need to override the keyPress
              // handler of the container div
              onKeyPress={a11yButtonHandler(this.actionClick)}
              style={actionStyle}
            >
              {actionText}
            </button>
          )}
        </div>
        {addendum && <div className={cn('inline-block', 'text-sm', 'leading-5')}>{addendum}</div>}
      </div>
    )
  }
}

export default ButterBar
